module.exports = __webpack_public_path__ + "img/VetoSansCond-BoldItalic_1.b24b3a24.svg";